export default __webpack_public_path__ + "static/media/enjoy_result_new.2226b6c8.png";